import { render, staticRenderFns } from "./RequestTypeCardSearch.vue?vue&type=template&id=2d077847&"
import script from "./RequestTypeCardSearch.vue?vue&type=script&lang=js&"
export * from "./RequestTypeCardSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports